/*
 * @Descripttion:
 * @version:
 * @Author: loong
 * @Date: 2022-09-07 18:19:41
 * @LastEditors: loong
 * @LastEditTime: 2022-09-23 11:37:02
 */

import Vue from 'vue'
import App from './App.vue'

import store from './store'
import router from './router'

import './utils/directives';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/base.css';

import copy from './utils/copy';

Vue.prototype.copy = copy;

import Clipboard from 'v-clipboard'

Vue.use(Clipboard);

Vue.use(ElementUI);

//全局引入echarts
import * as echarts from 'echarts'

Vue.prototype.$echarts = echarts

// 全局函数及变量
import Global from './Global';

Vue.use(Global);

// 公用文本库
import PublicText from './utils/message.js'

Vue.prototype.$PubText = PublicText;

import cookie from './utils/cookie.js';

Vue.prototype.$cookie = cookie;

import http from './utils/http';

Vue.prototype.$http = http;

import * as contUrl from './const';

Vue.prototype.$const = contUrl;

Vue.config.productionTip = false;

// highlight.js代码高亮插件
import Highlight from './utils/highlight.js'
Vue.use(Highlight);

// 时间过滤器
// 价格过滤器
import filters from './utils/filter';

// 全局过滤器
Object.keys(filters).forEach(filterName => {
  Vue.filter(filterName, filters[filterName]);
});
import i18n from './i18n';

Vue.use({
  i18n: (key, value) => i18n.t(key, value),
});





new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')